module.exports = __webpack_public_path__ + "6647a4efc24a2e52cc96dc06510955e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/authors/images/alarm.png
// module id = 854
// module chunks = 3